var MenuParameters = /** @class */ (function () {
    function MenuParameters(name, category, menu) {
        this.name = name;
        this.category = category;
        this.menu = menu;
    }
    return MenuParameters;
}());
export { MenuParameters };
